import { getPosition } from '../utils';

export default class AnimationExpandWidth {
  constructor(el) {
    this.$el = $(el);
    this.$content = this.$el.find('.expand-content');
    this.percent = 0;
    this.windowScroll = 0;
    this.positionFlag = 0;

    this.classes = {
      startNow: 'start-now',
      startAniScroll: 'start-ani-scroll',
    };

    this.init();
  }

  init() {
    this.addListeners();
    this.handleScroll();
    this.checkImageLoad();
  }

  addListeners() {
    window.scrollAgent.scrollEvent((args) => {
      this.windowScroll = parseFloat(args.scroll.y.toFixed(2));
      if (this.positionFlag !== this.windowScroll) {
        this.positionFlag = this.windowScroll;
        this.handleScroll();
      }
    });
  }

  checkImageLoad() {
    this.$el.parents('.wrap-model').find('img:not(.image-loaded)').each((_index, item) => {
      const $img = $(item);
      if (item.complete) {
        $img.addClass('image-loaded');
      } else {

        $img.on('error', () => {
          $img.addClass('image-error');
        });
        $img.on('load', () => {
          if (!$img.hasClass('image-error')) {
            $img.addClass('image-loaded');
          }
        });
      }
    });
  }

  handleScroll() {
    if (this.$el.length) {
      if ($(window).innerWidth() > 1199) {
        const offsetModule = getPosition(this.$el.get(0)).y;
        const heightModule = this.$el.innerHeight();
        const heightWindow = $(window).innerHeight();
        const scrollTopWindow = this.windowScroll;

        let positionAni = 100;
        if (this.$el.hasClass('first-expand')) {
          setTimeout(() => {
            this.$el.addClass(this.classes.startNow);
            setTimeout(() => {
              this.$el.addClass(this.classes.startAniScroll);
            }, 500);
          }, 400);
          return false;
        }
        this.handleScrollChild(scrollTopWindow, heightWindow, offsetModule, heightModule);
        if (this.$el.hasClass('version-top')) {
          positionAni = 400;
        }
        if (scrollTopWindow + heightWindow > offsetModule + heightModule - positionAni) {
          this.$el.addClass(this.classes.startAniScroll);
        } else {
          this.$el.removeClass(this.classes.startAniScroll);
        }
      } else {
        this.$el.css({ width: '', height: '' });
      }
    }
    return true;
  }

  handleScrollChild(scrollTopWindow, heightWindow, offsetModule, heightModule) {
    if (scrollTopWindow + heightWindow > offsetModule) {
      const countOf = scrollTopWindow + heightWindow - offsetModule;
      const numberScrollTmp1 = offsetModule + heightModule - heightModule / 3;
      const numberScrollTmp2 = numberScrollTmp1 - offsetModule;
      let numberScrollTmp3 = (50 / numberScrollTmp2) * countOf;
      if (numberScrollTmp3 > 80) {
        numberScrollTmp3 = 80;
      }
      this.percent = numberScrollTmp3 + 20;
      this.$el.css('width', `${this.percent}%`);
    }

  }
}
